import { SvgIcon } from '@material-ui/core'

export default function VolumeOffIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M14.6096 4.84591C14.5115 4.06128 13.5846 3.6955 12.9771 4.20172L7.95804 8.38431C7.86818 8.45919 7.75492 8.5002 7.63795 8.5002H3.75C3.05964 8.5002 2.5 9.05984 2.5 9.7502V14.2502C2.5 14.9406 3.05964 15.5002 3.75 15.5002H7.63795C7.75492 15.5002 7.86818 15.5412 7.95804 15.6161L12.9771 19.7987C13.5846 20.3049 14.5115 19.9391 14.6096 19.1545L14.7054 18.388C15.2357 14.146 15.2357 9.85443 14.7054 5.61241L14.6096 4.84591Z"
                fill="currentColor"
            />
            <path
                d="M17.2374 9.7021C17.5303 9.4092 18.0052 9.4092 18.2981 9.7021L19.5355 10.9395L20.773 9.7021C21.0659 9.4092 21.5407 9.4092 21.8336 9.7021C22.1265 9.99499 22.1265 10.4699 21.8336 10.7628L20.5962 12.0002L21.8336 13.2376C22.1265 13.5305 22.1265 14.0054 21.8336 14.2983C21.5407 14.5912 21.0659 14.5912 20.773 14.2983L19.5355 13.0609L18.2981 14.2983C18.0052 14.5912 17.5303 14.5912 17.2374 14.2983C16.9445 14.0054 16.9445 13.5305 17.2374 13.2376L18.4749 12.0002L17.2374 10.7628C16.9445 10.4699 16.9445 9.99499 17.2374 9.7021Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
